import { render, staticRenderFns } from "./CameraCapture.vue?vue&type=template&id=62656a2b&"
import script from "./CameraCapture.vue?vue&type=script&lang=ts&"
export * from "./CameraCapture.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports